
import React from 'react';

const DiscountLabel = ({ text, additionalClass }) => {
    return (<div className={`discount-label__container ${additionalClass}`}>
        <span className='discount-label__discount-text'>{text}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
            <circle cx="30.457" cy="30.7598" r="30" fill="#DA291C" />
        </svg>
    </div>);
}

export default DiscountLabel;